/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { RouteComponentProps } from "react-router-dom";
import NavigationView from "../../../../Basis/Components/NavigationView";
import NavigationLink from "../../../../Basis/Components/NavigationView/NavigationLink";
import NavigationViewModel from "../../../../Basis/Components/NavigationView/NavigationViewModel";
import { translationKeys, useTranslation } from "../../Internationalisierung/i18nMandanten";
import Beleg from "../../Queries/Beleg";
import LadeBelegeZuMandant from "../../Queries/LadeBelegeZuMandant";
import BelegeUrlsBuilder from "../../Utils/BelegeUrlsBuilder";

type MandantBelegeNavigationViewProps = RouteComponentProps<{ belegId: string }>;

class MandantBelegeNavigationViewModel extends NavigationViewModel {
    private readonly _query: LadeBelegeZuMandant;

    public constructor(private readonly _props: MandantBelegeNavigationViewProps, titel: string) {
        super(titel, _props.history);
        this._query = new LadeBelegeZuMandant(this.queryOnCompleted);
    }

    public get links(): NavigationLink[] {
        return this.state.daten.map((beleg: Beleg) => ({
            bezeichnung: beleg.nummer,
            url: BelegeUrlsBuilder.getBelegUrl(beleg.art, beleg.id),
            istAusgewaehlt: this._props.match.params.belegId === beleg.id,
        }));
    }

    public finde = (suchbegriff: string): void => {
        this._setLoading(false);
    };

    protected readonly onDatenGeladen = (daten: Beleg[]): void => {
        this.setState(nextState => {
            nextState.daten = daten;
        });
    };
}

export default function MandantBelegeNavigationView(props: MandantBelegeNavigationViewProps) {
    const { t } = useTranslation();
    return (
        <NavigationView
            model={new MandantBelegeNavigationViewModel(
                props,
                t(translationKeys.mandantBelegeNavigationView.belege)
            )}
        />
    );
}
